import * as React from "react";
import { useEffect } from "react";
import { ShareWindow } from "../../share/shareWindow";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { useClinicData } from "../../../clinic/clinicHooks";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface WhatsNextShareCaseProps {
  open?: boolean;
  onClose?: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const WhatsNextShareCase = ({
  open,
  ...props
}: WhatsNextShareCaseProps) => {
  const { name: clinicName, clinic: clinicId } = useClinicData();

  useEffect(() => {
    evt({
      category: CATEGORY.PATIENT_RESULT,
      action: ACTION.PATIENT_WHATS_NEXT,
      label: `Share with your doctor clicked`,
      props: {
        clinicName,
        clinicId,
      },
    });
  }, [clinicName, clinicId]);

  return <ShareWindow windowOnly open={open} onClose={props.onClose} />;
};
